import { useState, cloneElement } from 'react';
import { Check, Copy as CopyIcon } from 'lucide-react';

import { cn } from '@/lib/utils';

const Copy = ({
  text,
  copyIcon,
  className,
}: {
  text: string;
  copyIcon?: React.ReactNode;
  className?: string;
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('copy failed:', err);
    }
  };
  if (copied) {
    return <Check className={cn('h-6 w-6 text-green-500', className)} />;
  }
  if (copyIcon) {
    return cloneElement(
      copyIcon as React.ReactElement<React.SVGProps<SVGSVGElement>>,
      {
        onClick: handleCopy,
      }
    );
  }
  return (
    <CopyIcon
      className={cn('h-6 w-6 cursor-pointer', className)}
      onClick={handleCopy}
    />
  );
};

export default Copy;
